// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609141704/js/" + chunkId + "." + {"44":"09f323eb","225":"ba6cb587","481":"982a36dc","486":"37b4af55","770":"ff028d69"}[chunkId] + ".0.5930867686762001.chunk.js";
};